import { Link } from 'react-router-dom';

function TermsOfService() {
  return (
    <div className="min-h-screen bg-offwhite py-16 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12">
          <Link to="/" className="inline-block mb-8 text-gray-600 hover:text-gray-900 transition-colors">
            ← Back to Home
          </Link>
          <h1 className="text-5xl md:text-6xl font-light text-gray-900 mb-4 text-smooth">
            Terms of Service
          </h1>
          <p className="text-gray-500 text-sm">Last updated: {new Date().toLocaleDateString()}</p>
        </div>

        <div className="prose prose-lg max-w-none">
          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">1. Agreement to Terms</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              By accessing or using Instnce, you agree to be bound by these Terms of Service and all applicable 
              laws and regulations. If you do not agree with any of these terms, you are prohibited from using 
              or accessing this service.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">2. Description of Service</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Instnce is a platform that enables users to trade digital content like stocks, including but not 
              limited to social media posts, images, videos, and other user-generated content. The platform 
              facilitates transactions between users and provides tools for evaluating and exchanging digital content.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">3. User Accounts</h2>
            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">3.1 Account Creation</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              To use certain features of the Service, you must register for an account and provide accurate, 
              current, and complete information. You are responsible for maintaining the confidentiality of your 
              account credentials and for all activities that occur under your account.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">3.2 Eligibility</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You must be at least 18 years old to use this Service. By creating an account, you represent and 
              warrant that you meet this age requirement and have the legal capacity to enter into these Terms.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">3.3 Account Responsibilities</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You are responsible for all activities conducted through your account, including transactions, 
              communications, and content sharing. You agree to immediately notify us of any unauthorized use 
              of your account or any other breach of security.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">4. User Conduct</h2>
            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">4.1 Acceptable Use</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You agree not to use the Service to:
            </p>
            <ul className="text-gray-700 mb-4 space-y-2 ml-6">
              <li>Violate any applicable laws or regulations</li>
              <li>Infringe upon the intellectual property rights of others</li>
              <li>Upload, post, or transmit harmful, threatening, abusive, or discriminatory content</li>
              <li>Engage in fraudulent, deceptive, or manipulative activities</li>
              <li>Distribute malware, viruses, or other harmful code</li>
              <li>Impersonate any person or entity or falsely state affiliation</li>
              <li>Interfere with or disrupt the Service or servers</li>
              <li>Collect or harvest personal information about other users</li>
            </ul>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">4.2 Content Ownership</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You retain all ownership rights to content you create or upload to the Service. By posting content, 
              you grant us a worldwide, non-exclusive, royalty-free license to use, reproduce, and display your 
              content solely for the purpose of operating and providing the Service to you and other users.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">5. Transactions and Payments</h2>
            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">5.1 Transaction Processing</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              All transactions are processed through third-party payment processors. We are not responsible for 
              payment processing errors or delays. Transaction fees may apply as disclosed during the checkout process.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">5.2 Refunds and Cancellations</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Refund policies apply as specified during each transaction. Some transactions may be final and 
              non-refundable. You acknowledge that digital content transactions carry inherent risks and may 
              lose value over time.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">5.3 Investment Risks</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              Trading digital content carries financial risks. Content values may fluctuate and may become worthless. 
              You acknowledge that you may lose your entire investment. Past performance is not indicative of future results.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">6. Intellectual Property</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              The Service and its original content, features, and functionality are owned by Instnce and are protected 
              by international copyright, trademark, patent, trade secret, and other intellectual property laws. 
              You may not modify, copy, distribute, transmit, display, perform, or create derivative works from 
              the Service without our express written permission.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">7. Disclaimers</h2>
            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">7.1 Service Availability</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We strive to keep the Service available, but we do not guarantee uninterrupted or error-free operation. 
              The Service is provided "as is" and "as available" without warranties of any kind, either express or implied.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">7.2 Content Accuracy</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We do not warrant the accuracy, completeness, or usefulness of any information on the Service. 
              We are not responsible for user-generated content or third-party content accessed through the Service.
            </p>

            <h3 className="text-xl font-normal text-gray-800 mb-3 mt-6">7.3 Financial Disclaimers</h3>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We are not financial advisors. Information provided on the platform is for informational purposes only 
              and does not constitute financial advice. Trading digital content involves substantial risk of loss.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">8. Limitation of Liability</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              To the fullest extent permitted by applicable law, in no event shall Instnce, its officers, directors, 
              employees, or agents be liable for any indirect, incidental, special, consequential, or punitive damages, 
              or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, 
              use, goodwill, or other intangible losses resulting from your use of the Service.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">9. Indemnification</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              You agree to defend, indemnify, and hold harmless Instnce and its officers, directors, employees, 
              and agents from and against any claims, damages, obligations, losses, liabilities, costs, or debt, 
              and expenses (including attorney's fees) arising from your use of the Service, violation of these Terms, 
              or infringement of any intellectual property or other right of any person or entity.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">10. Termination</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We may terminate or suspend your account and access to the Service immediately, without prior notice 
              or liability, for any reason, including if you breach these Terms. Upon termination, your right to 
              use the Service will cease immediately.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">11. Governing Law</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              These Terms shall be interpreted and governed by the laws of [Your Jurisdiction], without regard to 
              its conflict of law provisions. Any disputes arising under or related to these Terms shall be subject 
              to the exclusive jurisdiction of the courts located in [Your Jurisdiction].
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">12. Changes to Terms</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a 
              revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. 
              Your continued use of the Service after changes become effective constitutes acceptance of the new Terms.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">13. Severability</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              If any provision of these Terms is found to be unenforceable or invalid, that provision will be limited 
              or eliminated to the minimum extent necessary, and the remaining provisions will remain in full force and effect.
            </p>
          </section>

          <section className="mb-12">
            <h2 className="text-2xl font-light text-gray-900 mb-4">14. Contact Information</h2>
            <p className="text-gray-700 mb-4 leading-relaxed">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <div className="bg-white rounded-lg p-6 border border-gray-200">
              <p className="text-gray-900">
                <strong>Email:</strong> founders@instnce.xyz
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;

